// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppVarsContext";
import LightboxPreview from "./views/lightbox-preview";
import LightboxPreviewc from "./views/lightbox-preview c";
import { Typography } from "@mui/material";
import StyleGuides from "./views/style-guides";





const App = () => {
  return (
    <Router>
      <AppProvider appid={"e3d68caa-1d5b-4614-8740-105fddc9794e"}>
        <Routes>
          <Route path="/" element={<StyleGuides />} />
          <Route path="/a/:pid" element={<LightboxPreview />} />
          <Route path="/c/:pid" element={<LightboxPreviewc />} />
        </Routes>
      </AppProvider>
    </Router>
  );
};

export default App;
